module.exports = __webpack_public_path__ + "img/738cb48.jpg";